module.exports = __webpack_public_path__ + "img/16.74a59ebd.png";